// extracted by mini-css-extract-plugin
export default {"btop":"f49abc0742 c4134aa134 _06e231395d","icon":"_108c149655 _125b6cefcf","btoppink":"ae24849a74 dfc321f8e7"};